import { render, staticRenderFns } from "./SecondaryCategories.vue?vue&type=template&id=da037a30"
import script from "./SecondaryCategories.vue?vue&type=script&lang=js"
export * from "./SecondaryCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports